export default "__VITE_ASSET__DA9lFBUk__"